import { useEffect, useState } from "react";
import { Download, FileText, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { t, fmtDate } from "../../lib/portalI18n";
import { usePortal } from "./PortalShell";
import { Card } from "./PortalOverview";

const humanSize = (n) => (!n ? "" : n > 1e6 ? `${(n / 1e6).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1e3))} KB`);

export default function PortalDocuments() {
  const { lang } = usePortal();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/portal/documents").then((r) => setData(r.data)).catch(() => setData({ groups: [], count: 0 })); }, []);
  const download = async (d) => {
    setBusy(d.id);
    try {
      const { data: r } = await api.post(`/portal/documents/${d.id}/download-url`);
      const a = document.createElement("a"); a.href = `${process.env.REACT_APP_BACKEND_URL}${r.url}`; a.download = d.filename || "document"; a.rel = "noopener"; document.body.appendChild(a); a.click(); a.remove();
    } finally { setBusy(""); }
  };
  if (!data) return <div className="text-sm text-slate-500">{t(lang, "loading")}</div>;
  return (
    <div className="space-y-5" data-testid="portal-documents">
      <h1 className="text-2xl font-semibold tracking-tight">{t(lang, "documents")}</h1>
      {data.count === 0 && <Card className="p-5 text-sm text-slate-500" testid="portal-no-documents">{t(lang, "no_documents")}</Card>}
      {data.groups.map((g) => (
        <section key={g.name} data-testid={`portal-doc-group-${g.name}`}>
          <div className="text-[11px] uppercase tracking-[0.16em] text-slate-400 font-semibold mb-2 px-1">{g.name}</div>
          <div className="space-y-2">
            {g.documents.map((d) => (
              <Card key={d.id} className="p-3 flex items-center gap-3" testid={`portal-doc-${d.id}`}>
                <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-700 flex items-center justify-center shrink-0"><FileText size={18} /></div>
                <div className="flex-1 min-w-0"><div className="font-medium truncate">{d.title}</div><div className="text-[11px] text-slate-400 truncate">{[(d.mime || "").split("/")[1]?.toUpperCase(), humanSize(d.size), d.shared_at ? `${t(lang, "shared_on")} ${fmtDate(d.shared_at, lang)}` : null].filter(Boolean).join(" · ")}</div></div>
                <button onClick={() => download(d)} disabled={busy === d.id} className="h-10 w-10 rounded-xl bg-[#0f1c17] text-white flex items-center justify-center active:scale-95 transition-transform disabled:opacity-50" data-testid={`portal-doc-download-${d.id}`} aria-label={t(lang, "download")}>{busy === d.id ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}</button>
              </Card>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
